import React, { Component, useState } from 'react';
import "./layer1.css";
import { useSpring, animated, config } from 'react-spring' // yarn add react-spring



function Layer1(){

  const styles = useSpring({
    loop: true,
    delay: 500,
    to: [
      { opacity: 1, color: '#ffaaee' },
      { opacity: 0, color: 'rgb(14,26,19)' },
    ],
    from: { opacity: 0, color: 'red' },
  })

  const styles2 = useSpring({
    loop: true,
    from: { rotateZ: 0 },
    to: { rotateZ: 180 },
  })

  const styles3 = useSpring({
    loop: {reverse : true},
    delay : 10,
    from: { translateY: "0px" },
    to: { translateY: "5px" },
  })

    return (
      <div className="title">
        <animated.div style={styles3} id="G"></animated.div>
        <animated.h1 style={styles}>Galactika</animated.h1>
        <animated.div style={styles2} id="cube"></animated.div>
      </div>
      
    );
  }
  
export default Layer1;